import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { EnvironmentService } from './environment.service'
import { Environment } from '../interfaces/environment.interface'
import { DynamicContent } from '../interfaces/dynamic-content.interface'
import { firstValueFrom } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  environment: Environment

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {
    this.environmentService.loadEnvironment().subscribe((env) => {
      this.environment = env
    })
  }

  async getDynamicContent(): Promise<DynamicContent> {
    return firstValueFrom(
      this.http.get(`${this.environment.dynamicContentEndpoint}`)
    ).then((dynamicContentRes: Object) => {
      return dynamicContentRes as DynamicContent
    })
  }
}
